/* eslint-disable prettier/prettier */
import { format, parseISO } from 'date-fns';
import React, { Fragment, useCallback, useEffect, useState } from 'react';

import { Button, Col, Container, Row } from 'react-bootstrap';
import { useRouteMatch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { FaSpinner, FaTrashAlt } from 'react-icons/fa';
import Agendamento, {
  IPacienteMaisCartaoDTO,
} from '../../components/Agendamento';
import Loading from '../../components/Loading';
import PacienteCabecalho from '../../components/PacienteCabecalho';
import { useClinica } from '../../hooks/clinica';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { formataCPF, formataIdade, formataTelefone } from '../../utils/funcoes';
import getResponseErrors from '../../utils/getResponseErrors';
import { IPacienteCodigo } from '../PacienteAtendimento';
import { Spinner } from '../../components/Agendamento/styles';
import Modal from '../../components/Modal';
import ComboAgendamento from './ComboAgendamento';
import ComboAgendamentoConsulta from './ComboAgendamentoConsulta';
import { IAgendamentoSelecionado } from '../AgendaBusca';

interface IUrlParams {
  AgeCodigo: string;
  ConfCodigo: string;
}

export interface IProcedimentosComboDTO {
  AgeCodigo: number;
  AgeConfCodigo: number;
  AgeMedUsuCodigo: number;
  AgeAteUsuCodigo: number;
  AgePacCodigo: number;
  AgeTipo: number;
  AgeObs: string;
  AgeInicio: string;
  AgeFim: string;
  AgeStatus: number;
  AgeFormaPag: number;
  AgeDataLiberacao: string;
  AgeEmail: any;
  AgePlano: boolean;
  AgeChave: string;
  AgePacStatus: number;
  AgePacStatusData: string;
  AgeClinica: number;
  AgeConfirmado: number;
  AgeOrigem: number;
  AgeTratamento: number;
  AgePagamentoMedico: number;
  AgeCombo: number;
  AgeGuia: string;
  AgeConvCodigo: number;
  created_at: string;
  updated_at: string;
  paciente: IPacienteDTO;
  procedimentos: IProcedimentoDTO[];
  possuiCartao: boolean;
  agendamentoConsulta?: IAgendamentos;
  procedimentosCombo: IProcedimentosCombo[];
}

interface IAgendamentos {
  AgeCodigo: number;
  AgeConfCodigo: number;
  AgeInicio: Date;
  DataInicioFormatada: string;
  AgeFim: Date;
  AgeStatus: number;
  updated_at: Date;
  ConNome: string;
  ProProCodigo: number;
}

export interface IPacienteDTO {
  PacCodigo: number;
  PacNome: string;
  PacNomeSocial: string;
  PacDataNasc: string;
  PacCPF: string;
  PacRG: string;
  PacCNPJ: string;
  PacIE: string;
  PacContato: string;
  PacTelefone: string;
  PacCelular: string;
  PacEmail: string;
  PacEmailValidado: boolean;
  PacEndereco: string;
  PacNumero: string;
  PacBairro: string;
  PacCidade: string;
  PacCidadeCodigo: string;
  PacCEP: string;
  PacComplemento: string;
  PacUF: string;
  PacDataCadastro: Date;
  PacSexo: string;
  PacProfissao: string;
  PacEstCivil: string;
  PacEscolaridade: string;
  PacObservacao: string;
  PacResponsavel: string;
  PacResponsavelCPF: string;
  PacResponsavelRG: string;
  PacAtivo: boolean;
  PacRestrito: boolean;
  PacFoto: string;
  PacChave: string;
  PacSenhaExame: string;
  PacPessoaFisica: boolean;
  PacClinica: number;
  PacOrigem: number;
  created_at: Date;
  updated_at: Date;
  avatar_url: string;
  PacPlanoSaude: number;
  PacNumeroCarteira: string;
}

export interface IProcedimentoDTO {
  ProCodigo: number;
  ProPerCodigo: number;
  ProNome: string;
  ProCodigoAlvaro: string;
  ProCor: any;
  ProIcone: any;
  ProValor: number;
  ProDuracao: number;
  ProRetorno: number;
  ProLimite: number;
  ProValorPlano: number;
  ProCarencia: number;
  ProValorPlano2: number;
  ProValorPlanoEmpresarial: number;
  ProAtivo: boolean;
  ProFavorito: boolean;
  ProOnline: boolean;
  created_at: string;
  updated_at: string;
  perfil: IPerfilDTO;
  ProValorCobrado: number;
}

export interface IPerfilDTO {
  PerCodigo: number;
  PerNome: string;
  PerTipo: number;
  PerAtivo: boolean;
  PerOnline: boolean;
  created_at: string;
  updated_at: string;
}

export interface IProcedimentosCombo {
  [key: string]: {
    procedimentos: IProcedimentoComboCompleto[];
    agendamentos: IAgendamentos[];
  };
}

export interface IProcedimentoComboCompleto {
  ChkCodigo: number;
  ProCodigo: number;
  ConfCodigo: number;
  procedimento: ProcedimentoCombo;
}

export interface ProcedimentoCombo {
  ProCodigo: number;
  ProPerCodigo: number;
  ProNome: string;
  ProDuracao: number;
  ProAgendado: boolean;
  perfil: {
    PerCodigo: number;
    PerNome: string;
    PerTipo: number;
  };
}

const PacoteCombo: React.FC = () => {
  const { addToast } = useToast();
  const { imagensClinica } = useClinica();
  const history = useHistory();
  const { params } = useRouteMatch<IUrlParams>();
  const [showAgenda, setShowAgenda] = useState(false);
  const [showAgendamento, setShowAgendamento] = useState(false);

  const { AgeCodigo, ConfCodigo } = params;

  const [paciente, setPaciente] = useState<
    IPacienteMaisCartaoDTO | undefined
  >();

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  const [pacienteSelecionado, setPacienteSelecionado] = useState<
    IPacienteCodigo | undefined
  >(
    paciente
      ? {
        ...paciente,
        PacTelefone: formataTelefone(paciente.PacTelefone),
        PacCelular: formataTelefone(paciente.PacCelular),
        PacCPF: formataCPF(paciente.PacCPF),
        PacDataNascFormatada: format(
          parseISO(paciente.PacDataNasc),
          'dd/MM/yyyy',
        ),
        PacIdade: formataIdade(parseISO(paciente.PacDataNasc)),
        avatar_url: paciente.avatar_url || semFoto,
        linkWhatsappWeb: '',
      }
      : undefined,
  );

  const [procedimentosDisponiveis, setProcedimentosDisponiveis] = useState<
    IProcedimentosCombo[]
  >();

  const [
    agendamentoConsulta,
    setAgendamentoConsulta,
  ] = useState<IAgendamentos>();

  const [procedimentosSelecionados, setProcedimentosSelecionados] = useState<
    ProcedimentoCombo[]
  >();

  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState<
    IAgendamentoSelecionado | undefined
  >(undefined);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IProcedimentosComboDTO>(
          `/agendamentos/${AgeCodigo}/combo`,
        );
        const {
          paciente: pacienteCombo,
          procedimentosCombo: procDisponiveis,
          agendamentoConsulta: ageConsulta,
          ...rest
        } = response.data;

        setProcedimentosDisponiveis(procDisponiveis);

        setPacienteSelecionado({
          ...pacienteCombo,
          PacTelefone: formataTelefone(pacienteCombo.PacTelefone),
          PacCelular: formataTelefone(pacienteCombo.PacCelular),
          PacCPF: formataCPF(pacienteCombo.PacCPF),
          PacDataNascFormatada: format(
            parseISO(pacienteCombo.PacDataNasc.toString()),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(pacienteCombo.PacDataNasc)),
          avatar_url: pacienteCombo.avatar_url || semFoto,
          linkWhatsappWeb: '',
        });

        if (ageConsulta)
          setAgendamentoConsulta({
            ...ageConsulta,
            DataInicioFormatada: format(
              parseISO(ageConsulta.AgeInicio.toString()),
              'dd/MM/yyyy HH:mm',
            ),
          });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar dados do agendamento',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }

    if (AgeCodigo && semFoto !== '') loadDados();
  }, [addToast, AgeCodigo, semFoto]);

  const handleSelectProcedimento = useCallback(
    (dados?: IProcedimentoComboCompleto[]) => {
      setProcedimentosSelecionados(undefined);
      if (dados)
        setProcedimentosSelecionados(
          dados.map(proc => {
            return { ...proc.procedimento };
          }),
        );
      setShowAgenda(true);
    },
    [],
  );
  const handleRecharge = useCallback(() => {
    window.location.reload();
  }, []);

  const handleRemoverAgendamento = useCallback(
    async (ageCodigo: number, updatedAt: Date) => {
      setLoading(true);
      try {
        await api.delete(
          `/agendamentos/combo/${ageCodigo}?updated_at=${updatedAt}`,
        );

        window.location.reload();
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar agendamentos',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  return (
    <>
      {loading && <Loading />}
      {showAgenda && pacienteSelecionado && procedimentosSelecionados && (
        <Modal
          show={showAgenda}
          titulo="Selecione os dados para agendamento"
          handleFecharModal={
            () => {
              setShowAgenda(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <ComboAgendamento
            comboId={Number(AgeCodigo)}
            pacCodigo={pacienteSelecionado.PacCodigo}
            handleFechar={() => handleRecharge()}
            perfil={procedimentosSelecionados[0].ProPerCodigo}
            procedimentos={procedimentosSelecionados}
          />
        </Modal>
      )}

      {showAgenda && pacienteSelecionado && !procedimentosSelecionados && (
        <Modal
          show={showAgenda}
          titulo="Selecione os dados para agendamento"
          handleFecharModal={
            () => {
              setShowAgenda(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <ComboAgendamentoConsulta
            comboId={Number(AgeCodigo)}
            pacCodigo={pacienteSelecionado.PacCodigo}
            handleFechar={() => handleRecharge()}
          />
        </Modal>
      )}

      {showAgendamento && agendamentoSelecionado && (
        <Modal
          show={showAgendamento}
          titulo="Agendamento"
          handleFecharModal={
            () => {
              setAgendamentoSelecionado(undefined);
              setShowAgendamento(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <Agendamento
            agendaId={agendamentoSelecionado.AgeConfCodigo}
            perfilId={undefined}
            data={undefined}
            AgeCodigo={agendamentoSelecionado.AgeCodigo}
            handleFecharAgendamento={() => {
              setShowAgendamento(false);
            }}
          />
        </Modal>
      )}
      <Container fluid className="mt-2">
        <div className="mb-2 p-2 bg-white border rounded">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h6 id="topoBusca">Dados Paciente</h6>
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              onClick={() => history.push('/listaCombo')}
            >
              Voltar para lista de Combos
            </Button>
          </div>
          {pacienteSelecionado && (
            <PacienteCabecalho
              paciente={pacienteSelecionado}
              pacienteID={pacienteSelecionado.PacCodigo}
            />
          )}
        </div>
        <div className="mb-2 p-2 bg-white border rounded">
          <Row>
            <Col>
              <div className="mb-2 p-2 border rounded">
                <b
                  style={{
                    marginBottom: '4px',
                    display: 'block',
                    fontSize: '1rem',
                  }}
                >
                  Procedimentos Disponíveis no Combo
                </b>

                <Row className="pl-2">
                  <Col md={12} lg={12} className="mt-2 d-none">
                    {procedimentosDisponiveis && (
                      <>
                        <Row key="linha-Consulta">
                          <Col
                            md={12}
                            lg={12}
                            className="mt-2"
                            style={{ fontWeight: 500 }}
                          >
                            <u>CONSULTA ESPECIALISTA</u>
                          </Col>
                        </Row>

                        <Row
                          key={`linha2-Consulta${9999999999 * Math.random()}`}
                          className="border-bottom pb-2"
                        >
                          <Col md={4} lg={4} className="mt-2">
                            <Row key="procs-Consulta">
                              <Col
                                md={12}
                                lg={12}
                                className={`mt-2 ${agendamentoConsulta ? 'font-weight-bold' : ''}`}
                              >
                                Consulta
                              </Col>
                            </Row>
                          </Col>
                          <Col md={8} lg={8} className="mt-2">
                            {agendamentoConsulta ? (
                              <Row
                                key={`linha3-${agendamentoConsulta.AgeCodigo}`}
                                className="align-items-center"
                              >
                                <Col>
                                  {agendamentoConsulta.ConNome.toUpperCase()}
                                </Col>
                                <Col md={3}>
                                  {agendamentoConsulta.DataInicioFormatada}
                                </Col>
                                <Col md={3}>
                                  <Button
                                    type="button"
                                    variant="outline-success"
                                    size="sm"
                                    data-id={agendamentoConsulta.AgeCodigo}
                                    onClick={() => {
                                      setAgendamentoSelecionado({
                                        AgeCodigo:
                                          agendamentoConsulta.AgeCodigo,
                                        AgeConfCodigo:
                                          agendamentoConsulta.AgeConfCodigo,
                                        ConNome: '',
                                      });
                                      setShowAgendamento(true);
                                    }}
                                  >
                                    Ver Agendamento
                                  </Button>
                                </Col>
                                <Col md={1}>
                                  <Button
                                    type="button"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => {
                                      handleRemoverAgendamento(
                                        agendamentoConsulta.AgeCodigo,
                                        agendamentoConsulta.updated_at,
                                      );
                                    }}
                                    disabled={loading}
                                  >
                                    <FaTrashAlt />
                                  </Button>
                                </Col>
                              </Row>
                            ) : (
                              <>
                                <Button
                                  type="button"
                                  variant="info"
                                  onClick={
                                    () => handleSelectProcedimento(undefined)
                                    // eslint-disable-next-line react/jsx-curly-newline
                                  }
                                  disabled={loading}
                                >
                                  {loading ? (
                                    <Spinner>
                                      <FaSpinner />
                                    </Spinner>
                                  ) : (
                                    'Agendar'
                                  )}
                                </Button>
                              </>
                            )}
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>

                  <Col md={12} lg={12} className="mt-2">
                    {procedimentosDisponiveis &&
                      procedimentosDisponiveis.map(
                        (proc: IProcedimentosCombo) => {
                          const chave = Object.keys(proc)[0];

                          return (
                            <Fragment key={`fragment-${chave}`}>
                              <Row key={`linha-${chave}`}>
                                <Col
                                  md={12}
                                  lg={12}
                                  className="mt-2"
                                  style={{ fontWeight: 500 }}
                                >
                                  <u className='font-weight-bold'>
                                    {proc[
                                      chave
                                    ].procedimentos[0].procedimento.perfil.PerNome.toString().toUpperCase()}
                                  </u>
                                </Col>
                              </Row>
                              <Row
                                key={`linha2-${chave}${9999999999 * Math.random()
                                  }`}
                                className="border-bottom pb-2"
                              >
                                <Col md={4} lg={4} className="mt-2">
                                  {proc[chave].procedimentos.map(p => {
                                    return (
                                      <Row key={`procs-${p.ProCodigo}`}>
                                        <Col
                                          md={12}
                                          lg={12}
                                          className={`mt-2 ${p.procedimento.ProAgendado
                                            ? 'font-weight-bold'
                                            : ''
                                            }`}
                                        >
                                          {p.procedimento.ProNome}
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                </Col>
                                <Col md={8} lg={8} className="mt-2">
                                  <>
                                    {proc[chave].agendamentos.length > 0 && (
                                      <>
                                        {proc[chave].agendamentos.map(agf => {
                                          const DataInicioFormatada = format(
                                            parseISO(agf.AgeInicio.toString()),
                                            'dd/MM/yyyy HH:mm',
                                          );

                                          return (
                                            <Row
                                              key={`linha3-${agf.AgeCodigo}`}
                                              className="align-items-center"
                                            >
                                              <Col>
                                                {agf.ConNome.toUpperCase()}
                                              </Col>
                                              <Col md={3}>
                                                {DataInicioFormatada}
                                              </Col>
                                              <Col md={3}>
                                                <Button
                                                  type="button"
                                                  variant="outline-success"
                                                  size="sm"
                                                  data-id={agf.AgeCodigo}
                                                  onClick={() => {
                                                    setAgendamentoSelecionado({
                                                      AgeCodigo: agf.AgeCodigo,
                                                      AgeConfCodigo:
                                                        agf.AgeConfCodigo,
                                                      ConNome: '',
                                                    });
                                                    setShowAgendamento(true);
                                                  }}
                                                >
                                                  Ver Agendamento
                                                </Button>
                                              </Col>
                                              <Col md={1}>
                                                <Button
                                                  type="button"
                                                  variant="outline-danger"
                                                  size="sm"
                                                  onClick={() => {
                                                    handleRemoverAgendamento(
                                                      agf.AgeCodigo,
                                                      agf.updated_at,
                                                    );
                                                  }}
                                                  disabled={loading}
                                                >
                                                  <FaTrashAlt />
                                                </Button>
                                              </Col>
                                            </Row>
                                          );
                                        })}
                                      </>
                                    )}

                                    {chave &&
                                      proc[chave].procedimentos.filter(
                                        proce =>
                                          proce.procedimento.ProAgendado ===
                                          false,
                                      ).length > 0 && (
                                        <Button
                                          type="button"
                                          variant="info"
                                          onClick={
                                            () =>
                                              handleSelectProcedimento(
                                                proc[
                                                  chave
                                                ].procedimentos.filter(
                                                  proce =>
                                                    proce.procedimento
                                                      .ProAgendado === false,
                                                ),
                                              )
                                            // eslint-disable-next-line react/jsx-curly-newline
                                          }
                                          disabled={loading}
                                        >
                                          {loading ? (
                                            <Spinner>
                                              <FaSpinner />
                                            </Spinner>
                                          ) : (
                                            'Agendar'
                                          )}
                                        </Button>
                                      )}
                                  </>
                                </Col>
                              </Row>
                            </Fragment>
                          );
                        },
                      )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default PacoteCombo;
